import { formatNumber, intlLocale } from './date';

export function formatRub(amount: number): string {
  const rounded = Math.round(amount);
  const sign = rounded < 0 ? '-' : '';
  const abs = Math.abs(rounded).toString();
  const withSeparator = abs.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `${sign}${withSeparator} ₽`;
}

const NBSP = ' ';

/**
 * Разряды суммы неразрывным пробелом: «137 400», «1 250.78». Без них пятизначная
 * цена читалась с запинкой, а обычный пробел давал переносу разорвать её надвое.
 * Дробная часть остаётся как пришла.
 */
export function groupDigits(value: number | string): string {
  const [whole, frac] = String(value).split('.');
  const sign = whole.startsWith('-') ? '-' : '';
  const grouped = whole.replace('-', '').replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
  return `${sign}${grouped}${frac !== undefined ? `.${frac}` : ''}`;
}

/** Целые рубли каталога со знаком: «1 575 ₽», пробелы неразрывные. */
export function rub(amount: number | string): string {
  return `${groupDigits(amount)}${NBSP}₽`;
}

/**
 * Сумма счёта из minor-единиц для кнопки оплаты: «125.78» с копейками, «126» без.
 *
 * Не округляем до рубля, как в каталоге: счёт провайдер выставит с копейками, и
 * кнопка «126 ₽» разошлась бы с ним. Точка, а не запятая, как в сообщениях бота.
 */
export function minorToAmount(minor: number): string {
  const value = Math.max(0, Math.round(minor));
  return groupDigits(value % 100 === 0 ? String(value / 100) : (value / 100).toFixed(2));
}

/** Знак валюты показа. Незнакомую пишем кодом: «100 EUR» лучше, чем чужой знак. */
export function currencySign(currency: string): string {
  if (currency === 'RUB') return '₽';
  if (currency === 'USD') return '$';
  return currency;
}

/**
 * Целая сумма из minor-единиц со знаком валюты: «1 250 ₽». Копейки отбрасываем:
 * суммы вывода целые, а доступное бэк уже округлил вниз.
 */
export function formatWholeMinor(minor: number, currency: string, lng?: string): string {
  const whole = Math.floor(minor / 100);
  return `${formatNumber(whole, lng)}${NBSP}${currencySign(currency)}`;
}

/**
 * Сумма из minor-единиц с копейками, если они есть: «128 499,90 ₽», «100 ₽».
 * Для баланса и истории операций: там человек сверяет деньги до копейки, а
 * `toLocaleString` по умолчанию давал «349,5 ₽» и терял ноль.
 */
export function formatMinor(minor: number, currency: string, lng?: string): string {
  const value = Math.round(minor);
  const digits = value % 100 === 0 ? 0 : 2;
  const amount = (value / 100).toLocaleString(intlLocale(lng), {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
  return `${amount}${NBSP}${currencySign(currency)}`;
}
